import { Link } from "@chakra-ui/react";
import { LinkProps } from "@chakra-ui/layout/dist/types/link";

interface IProps extends LinkProps {
  isDisabled?: boolean;
}

const SideDrawerLink = ({
  isDisabled = false,
  children,
  ...restProps
}: IProps) => {
  return (
    <Link
      {...(isDisabled && { color: "lightgray" })}
      _hover={{
        cursor: isDisabled ? "not-allowed" : "pointer",
        textDecoration: isDisabled ? "none" : "underline",
      }}
      {...restProps}
    >
      {children}
    </Link>
  );
};

export { SideDrawerLink };
